namespace GeniuzPOS.CustomReport {
    export interface ReportCusStockOnHandRow {
        Id?: string;
        BrandName?: string;
        SupplierId?: string;
        SuplierName?: string;
        Category1?: string;
        Category2?: string;
        Category3?: string;
        SkuCode?: string;
        PluCode?: string;
        SkuDesc?: string;
        HistorySaleAmt?: number;
        AvgSaleAmt?: number;
        OnHandQty?: number;
        StkUnit?: string;
        CostAmount?: number;
        SellPrice1?: number;
    }

    export namespace ReportCusStockOnHandRow {
        export const idProperty = 'Id';
        export const nameProperty = 'BrandName';
        export const localTextPrefix = 'CustomReport.ReportCusStockOnHand';
        export const deletePermission = '6CustomReport:StockOnHand:View';
        export const insertPermission = '6CustomReport:StockOnHand:View';
        export const readPermission = '6CustomReport:StockOnHand:View';
        export const updatePermission = '6CustomReport:StockOnHand:View';

        export declare const enum Fields {
            Id = "Id",
            BrandName = "BrandName",
            SupplierId = "SupplierId",
            SuplierName = "SuplierName",
            Category1 = "Category1",
            Category2 = "Category2",
            Category3 = "Category3",
            SkuCode = "SkuCode",
            PluCode = "PluCode",
            SkuDesc = "SkuDesc",
            HistorySaleAmt = "HistorySaleAmt",
            AvgSaleAmt = "AvgSaleAmt",
            OnHandQty = "OnHandQty",
            StkUnit = "StkUnit",
            CostAmount = "CostAmount",
            SellPrice1 = "SellPrice1"
        }
    }
}
